// Tracks whether a verification code has already been emailed this session, so
// the proactive post-sign-up send (useAuthentication) and the dialog's
// auto-send-on-open don't fire two codes back to back. Keyed by email so a
// different account in the same tab still auto-sends. Best-effort — a
// disabled/unavailable sessionStorage just means we may send an extra code.

const KEY = 'unify:verification-code-sent';

export function markCodeSent(email) {
	if (!email) return;
	try {
		window.sessionStorage.setItem(KEY, email);
	} catch {
		// ignore — worst case the dialog auto-sends one more code
	}
}

export function wasCodeSent(email) {
	if (!email) return false;
	try {
		return window.sessionStorage.getItem(KEY) === email;
	} catch {
		return false;
	}
}
